/**
 * variant-availability.js
 *
 * Dawn テーマ用アドオン
 *
 * 機能:
 *  - 初期表示では「選択不可」を表示しない
 *  - どれかのセレクトをユーザーが変更した後だけ「選択不可」を表示する
 *  - option は disabled にしない（選択は可能なまま）
 *  - カート追加処理は触らない
 */

(function () {
  'use strict';

  const STYLE_ID = 'variant-availability-style';
  const UNAVAILABLE_TEXT = '選択不可';

  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      variant-selects select option[data-unavailable] {
        color: #aaa;
        text-decoration: line-through;
      }
    `;
    document.head.appendChild(style);
  }

  function getBaseText(option) {
    return (option.dataset.baseText || option.textContent)
      .replace(new RegExp(`\\s*\\(${UNAVAILABLE_TEXT}\\)\\s*$`), '')
      .trim();
  }

  function resetOption(option) {
    if (!option.dataset.baseText) {
      option.dataset.baseText = getBaseText(option);
    }

    option.removeAttribute('data-unavailable');
    option.textContent = option.dataset.baseText;
  }

  function applyAvailability(el) {
    const jsonEl = el.querySelector('[type="application/json"]');
    if (!jsonEl) return;

    let variantData;

    try {
      variantData = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.warn('[variant-availability] JSON parse error', e);
      return;
    }

    const selects = Array.from(el.querySelectorAll('select'));
    if (selects.length === 0) return;

    const shouldShowUnavailable = el.dataset.userChangedAnyOption === '1';

    // 初期表示では、全選択肢を通常表示に戻す
    if (!shouldShowUnavailable) {
      selects.forEach((select) => {
        Array.from(select.options).forEach((option) => {
          resetOption(option);
        });
      });
      return;
    }

    const selectedOptions = selects.map((s) => s.value);

    selects.forEach((select, selectIndex) => {
      Array.from(select.options).forEach((option) => {
        if (!option.dataset.baseText) {
          option.dataset.baseText = getBaseText(option);
        }

        const optionValue = option.value;

        const testOptions = [...selectedOptions];
        testOptions[selectIndex] = optionValue;

        const matchingVariants = variantData.filter((variant) =>
          testOptions.every((opt, idx) => {
            if (opt === null || opt === '') return true;
            return variant.options[idx] === opt;
          })
        );

        const isUnavailable =
          matchingVariants.length === 0 ||
          matchingVariants.every((v) => !v.available);

        if (isUnavailable) {
          option.setAttribute('data-unavailable', '');
          option.textContent = `${option.dataset.baseText} (${UNAVAILABLE_TEXT})`;
        } else {
          option.removeAttribute('data-unavailable');
          option.textContent = option.dataset.baseText;
        }
      });
    });
  }

  function processAll(root) {
    root.querySelectorAll('variant-selects').forEach((el) => {
      applyAvailability(el);

      if (!el.dataset.availabilityBound) {
        el.dataset.availabilityBound = '1';

        el.addEventListener('change', () => {
          // どれかのセレクトが変更されたら、以降は選択不可表示を有効化
          el.dataset.userChangedAnyOption = '1';
          applyAvailability(el);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => processAll(document));
  } else {
    processAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    processAll(event.target);
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;

        if (node.tagName === 'VARIANT-SELECTS') {
          applyAvailability(node);
        } else if (node.querySelector) {
          processAll(node);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();